module.exports = __webpack_public_path__ + "img/yamamoto.6a637fdc.png";